import dates from 'frontcore/utils/dates'
import i18n from 'frontcore/i18n'
import { computed, ref, Ref } from 'vue'
import { defineStore } from 'pinia'

// This is because of an ESlint bug: https://github.com/typescript-eslint/tslint-to-eslint-config/issues/856
// eslint-disable-next-line
export enum LicenceExpirationStatus {
  ACTIVE, ABOUT_TO_EXPIRE, EXPIRED
}

const LICENCE_EXPIRATION_THRESHOLD = 31

const useLicenceExpirationConfiguration = defineStore('licenceExpirationConfiguration', () => {
  const licenceExpirationDateString: Ref<string | undefined> = ref(undefined)
  const licenceRemainingDays = computed((): number => {
    if (!licenceExpirationDateString.value) { return -1 }
    const today = dates.getTodayUTCBegin() as string
    return dates.dateDiff(licenceExpirationDateString.value, today)
  })
  const licenceExpirationStatus = computed((): LicenceExpirationStatus => {
    if (licenceRemainingDays.value <= 0) { return LicenceExpirationStatus.EXPIRED }
    else if (licenceRemainingDays.value <= LICENCE_EXPIRATION_THRESHOLD) { return LicenceExpirationStatus.ABOUT_TO_EXPIRE }
    return LicenceExpirationStatus.ACTIVE
  })
  const licenceExpirationMessage = computed((): string => {
    if (licenceExpirationStatus.value === LicenceExpirationStatus.EXPIRED) {
      return i18n.global.t('common.messages.licence_expiration_expired')
    }
    return i18n.global.t(
      'common.messages.licence_expiration_remaining',
      { days: licenceRemainingDays.value }
    )
  })
  const isLicenceActive = computed((): boolean => {
    if (licenceExpirationDateString.value !== undefined) {
      return licenceExpirationStatus.value === LicenceExpirationStatus.ACTIVE
    }
    return true
  })
  return {
    licenceExpirationDateString,
    licenceExpirationMessage,
    licenceExpirationStatus,
    licenceRemainingDays,
    isLicenceActive,
  }
})

export default useLicenceExpirationConfiguration
